<template>
  <div class="modern-breadcrumbs">
    <v-breadcrumbs :items="routelinks" divider="›" class="breadcrumb-list pa-0 mb-3">
      <template slot="item" slot-scope="{ item }">
        <span
          class="breadcrumb-item"
          :class="{ 'breadcrumb-item--active': item.disabled }"
        >{{ item.text }}</span>
      </template>
    </v-breadcrumbs>
  </div>
</template>

<script>
export default {
  props: {
    routelinks: {}
  }
};
</script>

<style scoped lang="css">
.modern-breadcrumbs {
  margin-bottom: 4px;
}

.breadcrumb-list {
  font-family: 'Inter', 'Roboto', sans-serif !important;
}

.breadcrumb-item {
  font-size: 13px;
  color: #64748b;
  font-weight: 400;
  cursor: pointer;
  transition: color 0.15s ease;
}

.breadcrumb-item:hover {
  color: #1565C0;
}

.breadcrumb-item--active {
  color: #1e293b;
  font-weight: 600;
  cursor: default;
}

.breadcrumb-item--active:hover {
  color: #1e293b;
}
</style>
